import type { CreatePartner, Partner, PartnerDetail, UpdatePartner } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const partnersApi = {
  async list(): Promise<Partner[]> {
    return unwrap<Partner[]>(await api.api.admin.partners.$get())
  },

  async detail(id: string): Promise<PartnerDetail> {
    return unwrap<PartnerDetail>(await api.api.admin.partners[':id'].$get({ param: { id } }))
  },

  async create(input: CreatePartner): Promise<Partner> {
    return unwrap<Partner>(await api.api.admin.partners.$post({ json: input }))
  },

  async update(id: string, input: UpdatePartner): Promise<void> {
    await unwrap(await api.api.admin.partners[':id'].$patch({ param: { id }, json: input }))
  },

  async assignBusiness(businessId: string, partnerId: string | null): Promise<void> {
    await unwrap(
      await api.api.admin.businesses[':id'].partner.$put({
        param: { id: businessId },
        json: { partnerId },
      }),
    )
  },
}
